@if (supplierContractState()?.isLoading) {
  <app-edit-form-skeleton />
  <ui-skeleton class="block h-8 w-[174px] rounded-md mt-6" />
} @else if (!supplierContractState() || supplierContractState()?.error) {
  <ui-alert color="error">
    <ng-icon name="heroXCircle" size="20" slot="icon" class="!block" />
    {{ 'cockpit.supplierContracts.details.general.errorLoadingSupplierContract' | transloco }}
  </ui-alert>
} @else if (supplierContractState()?.data) {
  @if (supplierContractState()?.data; as supplierContract) {
    <app-supplier-contract-details-edit-form
      [supplierContract]="supplierContract"
      [supplierContractId]="supplierContractId()"
      [organizationId]="organizationId()"
    />
    <div class="mt-6">
      <ui-button
        mode="outlined"
        size="small"
        type="button"
        (click)="onClickDelete()"
        [loading]="isDeleteLoading()"
      >
        <div slot="start" class="text-error dark:text-error-darkmode">
          <ng-icon name="heroTrash" size="20" class="!block" />
        </div>
        <div class="text-error dark:text-error-darkmode">
          {{ 'cockpit.supplierContracts.details.general.deleteButton' | transloco }}
        </div>
      </ui-button>
    </div>
  }
}
